import { SelectionWithMultimediaMixin, SelectionWithNoteSourceCitationMixin } from './mixin';
import { SelectionIndividualReference, SelectionFamilyEvent } from './internal';
import { SelectionRecord } from './base';
export class SelectionFamilyRecord extends SelectionWithMultimediaMixin(SelectionWithNoteSourceCitationMixin(SelectionRecord)) {
    /* Events */
    getEventAnnulment() {
        return this.get("ANUL" /* Tag.Annulment */, null, SelectionFamilyEvent);
    }
    getEventCensus() {
        return this.get("CENS" /* Tag.Census */, null, SelectionFamilyEvent);
    }
    getEventDivorce() {
        return this.get("DIV" /* Tag.Divorce */, null, SelectionFamilyEvent);
    }
    getEventDivorceFiled() {
        return this.get("DIVF" /* Tag.DivorceFiled */, null, SelectionFamilyEvent);
    }
    getEventEngagement() {
        return this.get("ENGA" /* Tag.Engagement */, null, SelectionFamilyEvent);
    }
    getEventMarriageBann() {
        return this.get("MARB" /* Tag.MarriageBan */, null, SelectionFamilyEvent);
    }
    getEventMarriageContract() {
        return this.get("MARC" /* Tag.MarriageContract */, null, SelectionFamilyEvent);
    }
    getEventMarriage() {
        return this.get("MARR" /* Tag.Marriage */, null, SelectionFamilyEvent);
    }
    getEventMarriageLicense() {
        return this.get("MARL" /* Tag.MarriageLicense */, null, SelectionFamilyEvent);
    }
    getEventMarriageSettlement() {
        return this.get("MARS" /* Tag.MarriageSettlement */, null, SelectionFamilyEvent);
    }
    getEventResidence() {
        return this.get("RESI" /* Tag.Residence */, null, SelectionFamilyEvent); // Residence is normally an attribute
    }
    getEventOther() {
        return this.get("EVEN" /* Tag.Event */, null, SelectionFamilyEvent);
    }
    /* End events */
    getHusband() {
        return this.get("HUSB" /* Tag.Husband */, null, SelectionIndividualReference);
    }
    getWife() {
        return this.get("WIFE" /* Tag.Wife */, null, SelectionIndividualReference);
    }
    getChild() {
        return this.get("CHIL" /* Tag.Child */, null, SelectionIndividualReference);
    }
    getChildrenCount() {
        return this.get("NCHI" /* Tag.ChildrenCount */);
    }
}
//# sourceMappingURL=SelectionFamilyRecord.js.map